import Log from '../utils/logger';

class SEIParser {
    static parseSEI(data: Uint8Array, headerSize: number, pts: number) {
        let seiPtr = 0;
        // skip nal header
        seiPtr += headerSize;
        let payloadType = 0;
        let payloadSize = 0;
        let endOfCaptions = false;
        let b = 0;

        while (seiPtr < data.length) {
            payloadType = 0;
            do {
                if (seiPtr >= data.length) {
                    break;
                }
                b = data[seiPtr++];
                payloadType += b;
            } while (b === 0xff);

            // Parse payload size.
            payloadSize = 0;
            do {
                if (seiPtr >= data.length) {
                    break;
                }
                b = data[seiPtr++];
                payloadSize += b;
            } while (b === 0xff);

            const leftOver = data.length - seiPtr;

            if (payloadSize <= leftOver) {
                if (payloadType !== 5) {
                    break;
                }

                endOfCaptions = true;

                if (payloadSize > 16) {
                    const uuidStrArray: Array<string> = [];
                    for (let i = 0; i < 16; i++) {
                        const b = data[seiPtr++].toString(16);
                        uuidStrArray.push(b.length == 1 ? '0' + b : b);

                        if (i === 3 || i === 5 || i === 7 || i === 9) {
                            uuidStrArray.push('-');
                        }
                    }
                    const length = payloadSize - 16;
                    const userDataBytes = new Uint8Array(length);
                    for (let i = 0; i < length; i++) {
                        userDataBytes[i] = data[seiPtr++];
                    }

                    return {
                        pts,
                        uuid: uuidStrArray.join(''),
                        userData: utf8ArrayToStr(userDataBytes),
                        userDataBytes,
                    };
                } else {
                    Log.w('SEIParser', `Found SEI with invalid payload size ${payloadSize} near timestamp ${pts}`);
                }
            } else if (payloadSize > leftOver) {
                break;
            }
        }
    }
}

let decoder: TextDecoder;

function getTextDecoder() {
    if (!decoder && typeof self.TextDecoder !== 'undefined') {
        decoder = new self.TextDecoder('utf-8');
    }

    return decoder;
}

export const utf8ArrayToStr = (array: Uint8Array, exitOnNull: boolean = false): string => {
    const decoder = getTextDecoder();
    if (decoder) {
        const decoded = decoder.decode(array);

        if (exitOnNull) {
            // grab up to the first null
            const idx = decoded.indexOf('\0');
            return idx !== -1 ? decoded.substring(0, idx) : decoded;
        }

        // remove any null characters
        return decoded.replace(/\0/g, '');
    }

    const len = array.length;
    let c;
    let char2;
    let char3;
    let out = '';
    let i = 0;
    while (i < len) {
        c = array[i++];
        if (c === 0x00 && exitOnNull) {
            return out;
        } else if (c === 0x00 || c === 0x03) {
            // If the character is 3 (END_OF_TEXT) or 0 (NULL) then skip it
            continue;
        }
        switch (c >> 4) {
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
                // 0xxxxxxx
                out += String.fromCharCode(c);
                break;
            case 12:
            case 13:
                // 110x xxxx   10xx xxxx
                char2 = array[i++];
                out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f));
                break;
            case 14:
                // 1110 xxxx  10xx xxxx  10xx xxxx
                char2 = array[i++];
                char3 = array[i++];
                out += String.fromCharCode(((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0));
                break;
            default:
        }
    }
    return out;
};

export default SEIParser;
